import { useState } from "react";

export const  useToggle = (initial) => {
    const [value, setValue] = useState(initial);

    const toggle = () => setValue( p => !p);
    return [value, setValue, toggle];
}

